import type { IconSvgObject } from './types';

const HeartPlusIcon: IconSvgObject = [
  ["path", { d: "M15 16H21M18 13V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 20.1561C13.8577 20.2656 13.7205 20.3696 13.5893 20.4677C12.6399 21.1776 11.3601 21.1776 10.4107 20.4677C7.58942 18.358 2 13.5348 2 9.19444C2 6.32563 4.10526 4 7 4C8.5 4 10 4.5 12 6.5C14 4.5 15.5 4 17 4C19.8947 4 22 6.32563 22 9.19444C22 9.78996 21.8948 10.3946 21.7059 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HeartPlusIcon;
